'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.daysUntil;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/daysUntil.js
// module id = 176
// module chunks = 1